export const getTotalYearGrossMargin = (value) => {
    return {
      type: "GET_TOTAL_YEAR_GROSS_MARGIN",
      payload: value,
    };
  };
  